import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

addToChainAfter(chain, RequestDataFromApi, props => {
    const state = props.getState();

    Object.keys(props.apiResult.categoriesById).forEach(categoryId => {
        const category = props.apiResult.categoriesById[categoryId];
        const stateCategory = getCategoryState(state, categoryId)?.value;

        if (category && stateCategory) {
            const { htmlContent } = stateCategory;

            Object.assign(category, {
                htmlContent,
            });
        }
    });
});
